import { Injectable } from '@angular/core';
import { tap, mapTo, switchMap } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { of, Observable } from 'rxjs';
import { AddressStore } from './address.store';
import { AddressQuery } from './address.query';
import { Address } from './models/address.model';
import { TopUpAddress } from './models/top-up-address.model';
import { AddressModel } from '../../user/models/address.model';

@Injectable({ providedIn: 'root' })
export class AddressService {
  constructor(
    private addressStore: AddressStore,
    private addressQuery: AddressQuery,
    private api: ApiService,
  ) {}

  /** Fetches the addresses and puts them in the store. */
  fetchAddresses(): Observable<null> {
    this.addressStore.setLoading(true);

    const request$: Observable<null> = this.api.get<Address>('addresses').pipe(
      tap(addresses => this.addressStore.set(addresses)),
      mapTo(null)
    );

    return this.addressQuery.getHasCache() ? of(null) : request$;
  }

  /** Save address */
  saveAddress(address: AddressModel): Promise<any> {
    return this.api.put<AddressModel>('addresses', '', address).pipe(
      tap(() => this.addressStore.setHasCache(false)),
      switchMap(() => this.fetchAddresses())
    ).toPromise();
  }

  public getTopUpAddress(): Observable<TopUpAddress> {
    return this.api.getAnySingle<TopUpAddress>('topup/topupaddress');
  }

  public postTopUpAddress(topupaddress: TopUpAddress): Promise<any> {
    return this.api.post('topup/topupaddress', topupaddress).toPromise();
  }
}
